import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReports = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M2.494 4.28a1 1 0 0 1 1-1h12.174a1 1 0 0 1 1 1v1.185a1 1 0 0 1-1 1H3.494a1 1 0 0 1-1-1zm0 5.356a1 1 0 0 1 1-1h12.174a1 1 0 0 1 1 1v1.185a1 1 0 0 1-1 1H3.494a1 1 0 0 1-1-1zm3.887 5.694a1 1 0 0 1 1-1h4.4a1 1 0 0 1 1 1v1.185a1 1 0 0 1-1 1h-4.4a1 1 0 0 1-1-1z" />
  </svg>
);
export default SvgReports;
